"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hashReg = /#[^?]*/;
function convertParams(params) {
    var paramsList = [];
    if (params && Object.keys(params).length) {
        for (var p in params) {
            if (params[p] !== "" && params[p] !== undefined) {
                paramsList.push(p + "=" + encodeURIComponent(params[p]));
            }
        }
    }
    return paramsList.join("&");
}
exports.convertParams = convertParams;
function genUrlWithSearch(url, params) {
    if (url === void 0) { url = ""; }
    if (url === undefined || url === "") {
        return "";
    }
    var postUrl = url;
    var hash = "";
    var hashResult = url.match(hashReg);
    if (hashResult !== null) {
        postUrl = url.replace(hashReg, "");
        hash = hashResult[0];
    }
    var searchString = convertParams(params);
    var startChat = "?";
    if (postUrl.includes("?")) {
        startChat = postUrl.endsWith("&") ? "" : "&";
    }
    return !!searchString ? "" + postUrl + startChat + searchString + hash : "" + url + hash;
}
exports.genUrlWithSearch = genUrlWithSearch;
exports.parseUrl = function (url) {
    var a = document.createElement("a");
    a.href = url;
    return {
        source: url,
        protocol: a.protocol.replace(":", ""),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function () {
            var ret = {}, seg = a.search.replace(/^\?/, "").split("&"), len = seg.length, i = 0, s;
            for (; i < len; i++) {
                if (!seg[i]) {
                    continue;
                }
                s = seg[i].split("=");
                ret[s[0]] = decodeURIComponent(s[1]);
            }
            return ret;
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ""])[1],
        hash: a.hash.replace("#", ""),
        path: a.pathname.replace(/^([^\/])/, "/$1"),
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ""])[1],
        segments: a.pathname.replace(/^\//, "").split("/")
    };
};
